// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"64fdbab9","455":"97fc1b7f","977":"32e05675"}[chunkId] + ".chunk.js";
};